import { AgriFieldList, CalendarFilter, WorkerList, Machine, PlantingList, WorkItem } from '@/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class CalendarSetting extends Vue {
  @Prop({})
  filter!: CalendarFilter;
  @Prop({})
  agriFields!: AgriFieldList[];
  @Prop({})
  workers!: WorkerList[];
  @Prop({})
  machines!: Machine[];
  @Prop({})
  plantings!: PlantingList[];
  @Prop({})
  workItems!: WorkItem[];
  private showAllAgriField = true;
  private showAllWorker = true;
  private showAllMachine = true;
  private showAllPlanting = true;
  private showAllWorkItem = true;
  private showItemNum = 3;

  private openModal() {
    this.$emit('openModal');
    this.$emit('sortModalToggle', true);
    this.$root.$emit('header-inert', true)
  }

  private get isAdmin(): boolean {
    let isAdmin = false;
    const loginUser = this.$store.getters.loginUser;
    loginUser.role.forEach((roleName: string) => {
      if (roleName === 'ADMIN') {
        isAdmin = true;
      }
    });
    return isAdmin;
  }

  private get agriFieldIds() {
    if (!this.showAllAgriField) {
      return this.filter.agriFieldIds.filter((id: string, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.filter.agriFieldIds;
  }

  private get workerIds() {
    if (!this.showAllWorker) {
      return this.filter.workerIds.filter((id: string, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.filter.workerIds;
  }

  private get machineIds() {
    if (!this.showAllMachine) {
      return this.filter.machineIds.filter((id: string, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.filter.machineIds;
  }

  private get plantingIds() {
    if (!this.showAllPlanting) {
      return this.filter.plantingIds.filter((id: string, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.filter.plantingIds;
  }

  private get workItemIds() {
    if (!this.showAllWorkItem) {
      return this.filter.workItemIds.filter((id: string, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.filter.workItemIds;
  }

  private get sortAgriFields() {
    if (!this.showAllAgriField) {
      return this.agriFields.filter((agriField: AgriFieldList, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.agriFields;
  }

  private get sortWorkers() {
    if (!this.showAllWorker) {
      return this.workers.filter((worker: WorkerList, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.workers;
  }

  private get sortMachines() {
    if (!this.showAllMachine) {
      return this.machines.filter((machine: Machine, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.machines;
  }

  private get sortPlantings() {
    if (!this.showAllPlanting) {
      return this.plantings.filter((planting: PlantingList, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.plantings;
  }

  private get sortWorkItems() {
    if (!this.showAllWorkItem) {
      return this.workItems.filter((workItem: WorkItem, index: number) => {
        return index < this.showItemNum;
      });
    }
    return this.workItems;
  }

  private showMore(type: string) {
    switch(type) {
      case 'agriField':
        this.showAllAgriField = true;
        break;
      case 'worker':
        this.showAllWorker = true;
        break;
      case 'machine':
        this.showAllMachine = true;
        break;
      case 'planting':
        this.showAllPlanting = true;
        break;
      case 'workItem':
        this.showAllWorkItem = true;
        break;
    }
  }

  private selectedAgriField(id: string) {
    return !!this.filter.agriFieldIds.find((agriFieldId: string) => agriFieldId === id);
  }

  private selectedWorker(id: string) {
    return !!this.filter.workerIds.find((workerId: string) => workerId === id);
  }

  private selectedMachine(id: string) {
    return !!this.filter.machineIds.find((machineId: string) => machineId === id);
  }

  private selectedPlanting(id: string) {
    return !!this.filter.plantingIds.find((plantingId: string) => plantingId === id);
  }

  private selectedWorkItem(id: string) {
    return !!this.filter.workItemIds.find((workItemId: string) => workItemId === id);
  }

  private getAgriFieldName(id: string) {
    const agriField = this.agriFields.find((agriField: AgriFieldList) => agriField.id === id);
    return agriField?.name;
  }

  private getWorkerName(id: string) {
    const worker = this.workers.find((worker: WorkerList) => worker.id === id);
    return worker?.name;
  }

  private getMachineName(id: string) {
    const machine = this.machines.find((machine: Machine) => machine.id === id);
    return machine?.name;
  }

  private getPlantingName(id: string) {
    const planting = this.plantings.find((planting: PlantingList) => planting.id === id);
    return planting?.name;
  }

  private getWorkItemName(id: string) {
    const workItem = this.workItems.find((workItem: WorkItem) => workItem.id === id);
    return workItem?.name;
  }
}